module.exports = __webpack_public_path__ + "c3449123f128172a8ce24b991028956c.MP3";